import {
  identityApiRef,
  discoveryApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import fetch from 'cross-fetch';
import { useAsync } from 'react-use';

// Allows calling external services using the proxy in the Backstage backend.
export function useProxy<T>(
  service: string,
  path: string,
  method: string = 'GET',
  query: Record<string, any> = {},
): {
  value: T | undefined;
  loading: boolean;
  error: Error | undefined;
} {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const { value, loading, error } = useAsync(async (): Promise<T> => {
    const apiUrl = `${await discoveryApi.getBaseUrl('proxy')}/${service}`;
    const { token: idToken } = await identityApi.getCredentials();
    const response = await fetch(
      `${apiUrl}/${path}?${new URLSearchParams(query).toString()}`,
      {
        method: method,
        headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
      },
    );

    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return (await response.json()) as T;
  }, []);
  return { value, loading, error };
}
